/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * PaymentGatewayProxy.Api | v1
 * OpenAPI spec version: 1.0.0
 */

export type AdminRole = typeof AdminRole[keyof typeof AdminRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminRole = {
  Viewer: 'Viewer',
  Admin: 'Admin',
  SuperAdmin: 'SuperAdmin',
} as const;
